export const SWAG_KIT = 'Swag kit';
export const SWAG_IN_A_BOX = 'Swag in a box';